( function () {
	const blocks = document.querySelectorAll( '.wp-block-milestonevideo-theme-faq' );
	if ( ! blocks.length ) return;

	blocks.forEach( function ( block ) {
		/* ---- Akordeon: jeden otwarty, klik w otwarty zamyka ---- */
		const items = block.querySelectorAll( '.faq__item' );

		const setHeight = ( item, open ) => {
			const answer = item.querySelector( '.faq__a' );
			if ( ! answer ) return;
			if ( open ) {
				answer.style.maxHeight = answer.scrollHeight + 'px';
			} else {
				answer.style.maxHeight = '0px';
			}
		};

		items.forEach( function ( item ) {
			const btn = item.querySelector( '.faq__q' );
			if ( ! btn ) return;

			// Stan startowy z render.php (.open na pierwszym itemie)
			setHeight( item, item.classList.contains( 'open' ) );

			btn.addEventListener( 'click', function () {
				const wasOpen = item.classList.contains( 'open' );

				items.forEach( function ( other ) {
					other.classList.remove( 'open' );
					const otherBtn = other.querySelector( '.faq__q' );
					if ( otherBtn ) otherBtn.setAttribute( 'aria-expanded', 'false' );
					setHeight( other, false );
				} );

				if ( ! wasOpen ) {
					item.classList.add( 'open' );
					btn.setAttribute( 'aria-expanded', 'true' );
					setHeight( item, true );
				}
			} );
		} );

		/* ---- Reveal on scroll ---- */
		const revealEls = block.querySelectorAll( '.reveal' );
		if ( ! revealEls.length ) return;

		const reduce = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
		if ( reduce ) {
			revealEls.forEach( function ( el ) {
				el.classList.add( 'in' );
			} );
			return;
		}

		const io = new IntersectionObserver(
			function ( entries ) {
				entries.forEach( function ( entry ) {
					if ( entry.isIntersecting ) {
						entry.target.classList.add( 'in' );
						io.unobserve( entry.target );
					}
				} );
			},
			{ threshold: 0, rootMargin: '0px 0px -10% 0px' } // wejście przy top < 90% viewportu
		);

		revealEls.forEach( function ( el ) {
			io.observe( el );
		} );
	} );
} )();
